import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../utils/utils';
import { DefaultValuesService } from '../../services/defaultvalues.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'quarter-selector',
    template: `Quarter:<br />
                    <ng-select labelForId="quarterSelect" style="border: 1px white solid" class="top-main-select"
                        (change)="onQuarterChange($event)"
                        [items]="quarterList"
                        bindLabel="Description"
                         bindValue="Id"
                         [closeOnSelect]="true"
                       [searchable]="true"
                       [(ngModel)]="defaults.quarterId">
                 </ng-select>`,
    styleUrls: ['../../style/mat-table.component.less'],
    standalone: false

})
export class QuarterSelectorComponent implements OnInit {

    protected _onDestroy = new Subject<void>();
    quarterList: Quarter[] = [];
    selectedQuarter = -1;

    private now: Date;
    private year: number;
    private month: number;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        public defaults: DefaultValuesService
    ) { 
        this.now = new Date();
        this.year = this.now.getFullYear();
        this.month = this.now.getMonth();
    }

    ngOnInit() {
        this.defaults.fiscalYearMessageChanges$
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.updateQuarterList();
            });

        if (this.defaults.fiscalYear && this.defaults.fiscalYear !== -1) {
            this.updateQuarterList();
        }
    }

    private updateQuarterList() {
        const currentFiscalYear = this.defaults.fiscalYear;

        // Showing only Q4 from previous fiscal year douring Q1 of current fiscal year
        if (currentFiscalYear === this.year && (this.month == 9 || this.month == 10 || this.month == 11)) {
            this.quarterList = [
                { Id: 4, Description: 'Q4: Period 12' }
            ];
            this.onQuarterChange(this.quarterList[0]);
        } else {
            this.quarterList = [
                { Id: 1, Description: 'Q1: Period 3' },
                { Id: 2, Description: 'Q2: Period 6' },
                { Id: 3, Description: 'Q3: Period 9' },
                { Id: 4, Description: 'Q4: Period 12' }
            ];
        }
    }

    ngOnChanges() { }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    ngAfterViewInit() { }

    sendPost(quarterId: number, callback: () => void) {
        var tthis = this;
        this.http
            .post<number>(this.baseUrl + Utils.getQuarter(), quarterId)
            .subscribe(() => {
                callback()
                },
                (error: any) => {
                    error => Utils.writeLog(tthis.http, tthis.baseUrl, error)
                }
            );
    }

    onQuarterChange(value: any) {
        this.sendPost(value.Id, () => {
            this.defaults.updateQuarter(value.Id);
        });  
    }
}